"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class Password extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'password';
        this._oldPassword = initParams.old_password;
        this._newPassword = initParams.new_password;
        this._status = initParams.status;
    }
    set oldPassword(value) {
        console.error('Do not set objects this way');
    }
    get oldPassword() {
        return this._oldPassword;
    }
    set newPassword(value) {
        console.error('Do not set objects this way');
    }
    get newPassword() {
        return this._newPassword;
    }
    set status(value) {
        console.error('Do not set objects this way');
    }
    get status() {
        return this._status;
    }
}
exports.default = Password;
//# sourceMappingURL=password.js.map